import { Typography } from '@mui/material';
import React from 'react';

const CaptionTypography = (props: any) => {
  
  return <Typography {...{ variant: 'caption', ...props }} />;
};
export default CaptionTypography